import React from 'react';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Tooltip from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Tooltip';
import PropTypes from 'prop-types';

const useStyles = buildUseStyles('FormattedTooltip', (() => ({
  tooltip: {
    whiteSpace: 'pre-wrap',
  },
})));

const FormattedTooltip = ({
  children,
  title,
}) => {
  const classes = useStyles();

  return (
    <Tooltip
      classes={{ tooltip: classes.tooltip }}
      title={title}
      placement="top"
      arrow
    >
      {children}
    </Tooltip>
  );
};

FormattedTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export default FormattedTooltip;
